import { useEffect } from "react";

export const SITE_ORIGIN = "https://ahjzn.cn";

export type PageMetaInput = {
  title: string;
  description: string;
  path: string;
  keywords?: string;
  type?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
};

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(data: Record<string, unknown> | Record<string, unknown>[]) {
  const id = "page-structured-data";
  document.head.querySelectorAll(`script[data-jsonld="${id}"]`).forEach((node) => node.remove());
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.setAttribute("data-jsonld", id);
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}

export function usePageMeta({ title, description, path, keywords, type = "website", jsonLd }: PageMetaInput) {
  useEffect(() => {
    const url = `${SITE_ORIGIN}${path}`;
    document.title = title;
    setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("name", "robots", "index,follow,max-image-preview:large");
    setCanonical(url);

    setMeta("property", "og:type", type);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:site_name", "看料吃瓜");
    setMeta("property", "og:locale", "zh_CN");

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    if (jsonLd) setJsonLd(jsonLd);

    return () => {
      const script = document.head.querySelector(`script[data-jsonld="page-structured-data"]`);
      if (script) script.remove();
    };
  }, [title, description, path, keywords, type, jsonLd]);
}